import api from './api';

export const adminService = {
  // Dashboard
  getDashboard: async () => {
    const response = await api.get('/admin/dashboard');
    return response.data;
  },

  // Users Management
  getUsers: async (params) => {
    const response = await api.get('/admin/users', { params });
    return response.data;
  },

  updateUserRole: async (userId, role) => {
    const response = await api.put(`/admin/users/${userId}/role`, { role });
    return response.data;
  },

  updateUserStatus: async (userId, status) => {
    const response = await api.put(`/admin/users/${userId}/status`, { status });
    return response.data;
  },

  // Investment Plans
  getInvestmentPlans: async () => {
    const response = await api.get('/admin/investment-plans');
    return response.data;
  },

  createInvestmentPlan: async (planData) => {
    const response = await api.post('/admin/investment-plans', planData);
    return response.data;
  },

  updateInvestmentPlan: async (planId, planData) => {
    const response = await api.put(`/admin/investment-plans/${planId}`, planData);
    return response.data;
  },

  deleteInvestmentPlan: async (planId) => {
    const response = await api.delete(`/admin/investment-plans/${planId}`);
    return response.data;
  },

  updatePlanStatus: async (planId, status) => {
    const response = await api.put(`/admin/investment-plans/${planId}/status`, { status });
    return response.data;
  },

  // MLM Management
  getMLMLevels: async () => {
    const response = await api.get('/admin/mlm/levels');
    return response.data;
  },

  createMLMLevel: async (levelData) => {
    const response = await api.post('/admin/mlm/levels', levelData);
    return response.data;
  },

  updateMLMLevel: async (levelId, levelData) => {
    const response = await api.put(`/admin/mlm/levels/${levelId}`, levelData);
    return response.data;
  },

  deleteMLMLevel: async (levelId) => {
    const response = await api.delete(`/admin/mlm/levels/${levelId}`);
    return response.data;
  },

  getMLMRanks: async () => {
    const response = await api.get('/admin/mlm/ranks');
    return response.data;
  },

  createMLMRank: async (rankData) => {
    const response = await api.post('/admin/mlm/ranks', rankData);
    return response.data;
  },

  updateMLMRank: async (rankId, rankData) => {
    const response = await api.put(`/admin/mlm/ranks/${rankId}`, rankData);
    return response.data;
  },

  deleteMLMRank: async (rankId) => {
    const response = await api.delete(`/admin/mlm/ranks/${rankId}`);
    return response.data;
  },

  // Transactions
  getTransactions: async (params = {}) => {
    const response = await api.get('/admin/transactions', { params });
    return response.data;
  },

  getTransactionStats: async () => {
    const response = await api.get('/admin/transactions/stats');
    return response.data;
  },

  updateTransactionStatus: async (transactionId, status) => {
    const response = await api.put(`/admin/transactions/${transactionId}/status`, { status });
    return response.data;
  },

  // KYC Management
  verifyKYC: async (userId, status, notes) => {
    const response = await api.put(`/admin/kyc/verify/${userId}`, { status, notes });
    return response.data;
  },

  // Withdrawals
  processWithdrawal: async (withdrawalId, action, notes) => {
    const response = await api.put(`/admin/withdrawals/${withdrawalId}/process`, { action, notes });
    return response.data;
  },

  // Reports
  generateReport: async (reportType, params) => {
    const response = await api.get('/admin/reports', { params: { report_type: reportType, ...params } });
    return response.data;
  },

  // Create Admin
  createAdminUser: async (userData) => {
    const response = await api.post('/admin/create-admin', userData);
    return response.data;
  },

  // Financial Stats
  getFinancialStats: async () => {
    const response = await api.get('/admin/dashboard/financial-stats');
    return response.data;
  },

  // System Settings
  getSystemSettings: async () => {
    const response = await api.get('/admin/settings');
    return response.data;
  },

  createSystemSetting: async (settingData) => {
    const response = await api.post('/admin/settings', settingData);
    return response.data;
  },

  updateSystemSettings: async (settings) => {
    const response = await api.put('/admin/settings', settings);
    return response.data;
  },

  deleteSystemSetting: async (id) => {
    const response = await api.delete(`/admin/settings/${id}`);
    return response.data;
  },

  // Investment Types
  getInvestmentTypes: async () => {
    const response = await api.get('/admin/investment-types');
    return response.data;
  },

  createInvestmentType: async (typeData) => {
    const response = await api.post('/admin/investment-types', typeData);
    return response.data;
  },

  updateInvestmentType: async (id, typeData) => {
    const response = await api.put(`/admin/investment-types/${id}`, typeData);
    return response.data;
  },

  deleteInvestmentType: async (id) => {
    const response = await api.delete(`/admin/investment-types/${id}`);
    return response.data;
  },

  // Market Analyses
  getAnalyses: async () => {
    const response = await api.get('/admin/analyses');
    return response.data;
  },

  createAnalysis: async (analysisData) => {
    const response = await api.post('/admin/analyses', analysisData);
    return response.data;
  },

  updateAnalysis: async (id, analysisData) => {
    const response = await api.put(`/admin/analyses/${id}`, analysisData);
    return response.data;
  },

  deleteAnalysis: async (id) => {
    const response = await api.delete(`/admin/analyses/${id}`);
    return response.data;
  }
};